<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pl-0">{{ $t("commons.drawer.authorisation") }}</v-card-title>
    </template>
    <template v-slot:content>
      <v-container>
        <v-form :readonly="!isEditable" ref="form">
          <v-select
            v-model="spending.vehicle"
            :disabled="!isEditable"
            :items="vehicles"
            :rules="rules.vehicles"
            item-text="registration_number"
            item-value="id"
            :label="$t('Vehicule')"
            chips
            attach
            outlined
          ></v-select>
          <v-text-field
            v-model="spending.requested_amount"
            :disabled="!isEditable"
            :rules="rules.requested_amount"
            :label="$t('Nombre de litre')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>
          <div style="margin-bottom: 25px">
            <label>{{ $t("commons.description") }}</label>
            <textarea
              :disabled="!isEditable"
              tag-name="textarea"
              rows="5"
              v-model="spending.justification"
              :config="editorConfig"
              :hint="$t('views.template.hint.description')"
              :label="$t('commons.message')"
              className="content-element"
            ></textarea>
          </div>
          <v-col class="d-flex justify-end gap-4">
            <avs-saveButton v-if="!loading" @click="save" :disabled="!isEditable" />
            <avs-button
              v-else
              icon
              color="secondary"
              class="spin-loading"
              :iconI="loading ? 'mdi-loading spin' : ''"
              label
              fab
              small
            />
            <avs-cancelButton @click="cancel" />
          </v-col>
        </v-form>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import { mkSpendingRequest } from "@/utils/datamodels";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { AuthorisationDetailService, CompanyVehiclesService } from "@/services";
import { required, max64 } from "@/utils/validator";
import _ from "lodash";

export default {
  name: "AuthorisationEditor",
  props: {
    hasUniqueName: {
      type: Function,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Object,
    },
  },
  computed: {
    spending: {
      get() {
        return _.cloneDeep(this.value || this.getDefaultValue());
      },
    },
  },
  data() {
    return {
      defaultItems: [],
      spendingRequest: mkSpendingRequest(),
      loading: false,
      rules: {
        description: [required],
        vehicle: [required],
        requested_amount: [required, max64],
      },
      vehicles: [],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "paragraph",
          "heading1",
          "heading2",
          "bold",
          "italic",
          "|",
          "link",
          "|",
          "undo",
          "redo",
          "-",
          "numberedList",
          "bulletedList",
        ],
      },
    };
  },
  created() {
    this.fetchFieldTypes();
  },
  methods: {
    fetchFieldTypes() {
      CompanyVehiclesService.get(this).then((response) => {
        this.vehicles = response.results;
      });
    },
    getDefaultValue() {
      return this.spendingRequest;
    },
    cancel() {
      this.$emit("cancel");
    },
    async performSave(data) {
      if (data.id > 0) {
        return AuthorisationDetailService.put(data);
      } else {
        return AuthorisationDetailService.post(data);
      }
    },
    async save() {
      this.loading = true;
      this.spending.lang = this.$i18n.locale;

      if (this.$refs.form.validate()) {
        try {
          const response = await AuthorisationDetailService.post(this.spending);
          this.$emit("input", response);
          this.$emit("success");
          this.loading = false;
        } catch (error) {
          const message = error?.external_emails;
          this.$emit("error", message);
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.ck.ck-editor__main > .ck-editor__editable {
  height: 200px;
}
.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by {
  display: none !important;
}
.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: var(--ck-border-radius);
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.ck-editor__editable {
  color: rgba(0, 0, 0, 0.87) !important;
}

.spin-loading {
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
